import { getShareModalConfig } from 'lib/customer/getShareModalConfig'
import { useMemo } from 'react'
import { useAppSelector } from './reduxHooks'

interface Props {
  utmCampaign?: string;
  location?: string;
  offerId: string;
  image?: App.Image;
  queryString?: string;
  type: 'offer' | 'bedbankOffer' | 'experience' | 'carHire';
  offerType?: 'hotel' | 'tour' | 'tour_v2' | 'cruise' | 'bedbank_hotel';
}

function useShareModalConfig(props: Props) {
  const url = useAppSelector((state) => state.system.customerPortalURL)
  const memberId = useAppSelector((state) => state.auth.account.memberId)
  const pathname = useAppSelector((state) => state.router.location.pathname)
  const region = useAppSelector((state) => state.geo.currentRegionCode)

  const config = useMemo(() => getShareModalConfig({
    customerPortalURL: url,
    memberId,
    offerId: props.offerId,
    offerLocation: props.location,
    pathname,
    region,
    type: props.type,
    utmCampaign: props.utmCampaign,
    image: props.image,
    queryString: props.queryString,
    offerType: props.offerType,
  }), [
    props.image,
    props.location,
    props.offerId,
    props.utmCampaign,
    props.type,
    url,
    memberId,
    pathname,
    region,
    props.queryString,
    props.offerType,
  ])

  return config
}

export default useShareModalConfig
